import { formatDateString, formatMoney } from "@cp/toolkit";
import { PRODUCTION_APP_ORIGINS } from "@/constants/app-origins";
import { useInboxInsured } from "@/providers/use-inbox-insured";
import { Row } from "../components/row";
import { Section, SectionHeader } from "../components/section";

export const ActiveDraftQuotes = () => {
  const { insuredId, draftQuotes } = useInboxInsured();
  return (
    <Section>
      <SectionHeader count={draftQuotes.length}>Draft Quotes</SectionHeader>
      {draftQuotes.map((quote) => {
        const { id, effectiveDate, premium, submission, state } = quote;
        return (
          <Row key={id} href={`${PRODUCTION_APP_ORIGINS.brokerage}/insured/${insuredId}/quotes/${id}`} state={state}>
            <div className="flex-2 space-y-0.5 truncate">
              <div className="font-medium truncate">{submission.appetiteProduct.carrierName}</div>
              <div className="text-muted-foreground truncate">{submission.appetiteProduct.carrierProductName}</div>
            </div>
            <div className="flex-1 space-y-0.5 truncate">
              <div className="font-medium truncate">{formatDateString(effectiveDate, "MMM d, yyyy")}</div>
              <div className="text-muted-foreground truncate">{formatMoney(premium || 0)}</div>
            </div>
          </Row>
        );
      })}
    </Section>
  );
};
